// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/line
import React, {useEffect, useState} from "react";
import {ResponsiveLine} from "@nivo/line";
import { dateMiladiToShamsi, dateMiladiToShamsiAndWeekday } from '../../../../method/date'
import data from "./data.json";
import {makeStyles} from "@mui/styles";
import {linearGradientDef} from "@nivo/core";
import {seprateNumberFromComma} from "../../../../method/seprateNumberFromComma";

const useStyles = makeStyles((theme) => ({
    tooltip: {
        background: "#fff",
        padding: 10,
        border: "0.5px solid #555",
        borderRadius: 2,
        boxShadow: "0px 0px 2px #000",
        direction: "rtl",
        textAlign: "right",
        minWidth: "310px",
    },
}));


const LineAreaChartNivo = React.memo(({reducerportfolio, daily_return, total_value}) => {

    const classes = useStyles();
    const [dataState, setdataState] = useState([]);
    const [min, setmin] = useState(0);

    function numToSkip(n, r) {
        if (r === "low") {
            if (n % 2 === 0 || n % 3 === 0) {
                return "even";
            } else {
                return "odd";
            }
        } else if (r === "mid") {
            if (n % 2 === 0 || n % 3 === 0 || n % 5 === 0) {
                return "even";
            } else {
                return "odd";
            }
        } else if (r === "high") {
            if (
                n % 2 === 0 ||
                n % 3 === 0 ||
                n % 5 === 0 ||
                n % 7 === 0 ||
                n % 9 === 0 ||
                n % 11 === 0 ||
                n % 13 === 0 ||
                n % 17 === 0
            ) {
                return "even";
            } else {
                return "odd";
            }
        }
    }

    const handleSkipdata = (data) => {
        let skip = [];

        if (data.length > 20 && data.length < 70) {
            for (let i = 0; i < data.length; i++) {
                if (numToSkip(i, "low") === "odd") {
                    skip.push(data[i]);
                }
            }
        } else if (data.length > 70 && data.length < 150) {
            for (let i = 0; i < data.length; i++) {
                if (numToSkip(i, "mid") === "odd") {
                    skip.push(data[i]);
                }
            }
        } else if (data.length > 150 && data.length < 400) {
            for (let i = 0; i < data.length; i++) {
                if (numToSkip(i, "high") === "odd") {
                    skip.push(data[i]);
                }
            }
        } else {
            skip = [...data];
        }

        return skip;
    };

    const handleDataCustom = () => {
        let sum = "";

        let portfolios = undefined
        if (total_value) {
            portfolios = [...reducerportfolio?.data]?.reverse();
        } else {
            portfolios = [...reducerportfolio?.data];
        }


        let wealth = []

        if (daily_return) {
            portfolios.forEach((portfolio, index) => {
                if (index === 0) {
                    wealth.push(1);
                } else {
                    wealth.push(wealth[index - 1] * (Math.exp(portfolio.body.daily_return)));
                }
            })
        }


        let arrReducer = portfolios?.map((itm, ind) => {
            if (daily_return) {
                let shamsi = dateMiladiToShamsiAndWeekday(itm.body.related_date.split(" ")[0])
                let {shamsiDate, weekday} = shamsi

                if (weekday === '4' || weekday === '5') {
                    return undefined
                }

                return {
                    y: wealth[ind],
                    x: shamsiDate,
                    realValue: itm.body.daily_return
                }

            }
            if (total_value) {
                return {
                    y: (itm.body.total_value / 10000000).toFixed(2),
                    x: dateMiladiToShamsi(itm.body.related_date.split(" ")[0]),
                    realValue: (itm.body.total_value / 10).toFixed(2)
                }
            }
        });
        arrReducer = arrReducer.filter(function (el) {
          return el != null;
        });
        let id = ''

        if (daily_return) {
            id = 'بازدهی روزانه'
        } else if (total_value) {
            id = 'دارایی کل'
        }
        let dataC = [
            {
                id,
                color: "#099c55",
                data: [...arrReducer],
            },
        ];
        let arr = [...dataC];
        let info = [];

        info = arr[0].data;
        arr[0].data = [...info];
        setdataState(arr);
    };

    useEffect(() => {
        handleDataCustom();
    }, [reducerportfolio.data]);

    useEffect(() => {
        let arr = [];
        let filter = dataState[0]?.data.map((itm, ind) => {
            return itm.y;
        });
        if (filter) {
            let min = Math.min(...filter);
            setmin(min);
        }
    }, [dataState]);

    const tooltipStyle = (d) => {
        let x = 150;
        let y = 0;

        if (d.point.x > 120) {
            x = 10;
        }
        if (d.point.x > 260) {
            x = -155;
        }

        if (d.point.y < 120) {
            y = 120;
        }

        return {transform: `translate(${x}px,${y}px)`};
    };

    const tooltipBody = (d) => {
        // let length = d.node.pathComponents.length
        // const groupName = d.node.pathComponents[length - 2]
    
        return (
            <div className={`${classes.tooltip}`} style={tooltipStyle(d)}>
                <div className="inline-block font-bold">{d.point.serieId}</div>
                <div className="grid grid-cols-12 w-full my-1">
                    <div className="col-span-5">تاریخ</div>
                    <div className="col-span-7">{`${d.point.data.x}`}</div>
                </div>

                <div className=" grid grid-cols-12 gap3 w-full my-1">
                    {
                        total_value ? (
                            <>
                                <div className="col-span-5">ارزش</div>
                                <div
                                    className="col-span-7">{`${(seprateNumberFromComma(d.point.data.realValue))}تومان `}</div>
                            </>
                        ) : (
                            daily_return ? (
                                <>
                                    <div className="col-span-5">بازدهی</div>
                                    <div className="col-span-7"
                                         style={{direction: "ltr"}}>{`${((d.point.data.y-1) * 100).toFixed(4)}%`}</div>
                                </>
                            ) : (
                                <></>
                            )
                        )
                    }
                </div>

            </div>
        );
    };

    return (
        <ResponsiveLine
            data={dataState}
            colors={(d) => d.color}
            margin={{top: 10, right: 20, bottom: 80, left: 60}}
            xScale={{type: "point"}}
            tooltip={(d) => tooltipBody(d)}
            enableGridX={false}
            yScale={{
                type: "linear",
                min: "auto",
                max: "auto",
                stacked: true,
                reverse: false,
            }}
            defs={[
                linearGradientDef("gradientA", [
                    {offset: 0, color: "inherit"},
                    {offset: 100, color: "inherit", opacity: 0},
                ]),
            ]}
            fill={[{match: "*", id: "gradientA"}]}
            yFormat=" >-.3f"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                orient: "bottom",
                tickSize: 5,
                tickPadding: 60,
                tickRotation: -90,
                // legend: "transportation",
                legendOffset: 36,
                legendPosition: "middle",
            }}
            axisLeft={{
                orient: "left",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                // legend: "count",
                legendOffset: -40,
                legendPosition: "middle",
            }}
            pointSize={12}
            pointColor={"#099c55"}
            pointBorderWidth={3}
            pointLabelYOffset={-12}
            enableArea={true}
            crosshairType="cross"
            areaBaselineValue={min}
            useMesh={true}
            legends={[]}
            motionConfig="stiff"
        />
    );
});

export default LineAreaChartNivo;
